export default __webpack_public_path__ + "static/media/bg-halopagi-3.07c17c4c.png";